import { ReactNode } from 'react';
import { Typography } from '../../../../core/components/molecules/Typography';
import { HeaderWrapper } from './variants';

interface ISectionHeader {
  hasTitle?: boolean;
  title?: string;
  children: ReactNode;
}

export default function SectionHeader({
  hasTitle = true,
  title,
  children,
}: ISectionHeader) {
  return (
    <div className={HeaderWrapper({ type: hasTitle ? 'title' : 'noTitle' })}>
      {hasTitle && (
        <Typography size='h5' type='titleSection'>
          {title}
        </Typography>
      )}
      {children}
    </div>
  );
}
